import { TableCacheKeyDto } from '@asset-metrix/portal-gateway-client-js';

import { useStore } from '../store';

import { prependRoleId } from './prependRoleId';
import { queryClient } from './queryClient';

export async function invalidateAllTableCaches(
  cacheKey: TableCacheKeyDto
): Promise<void> {
  useStore.getState().setAllFilterUnLoaded();

  await queryClient.invalidateQueries({
    queryKey: prependRoleId(['pageFilters']),
  });
  await invalidateTable(cacheKey);
}

export async function invalidateTable(
  cacheKey: TableCacheKeyDto,
  pageId?: string,
  widgetId?: string
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: prependRoleId([
        'tableFilters',
        ...(widgetId ? [widgetId] : []),
      ]),
    }),
    queryClient.invalidateQueries({
      queryKey: prependRoleId([
        'customQueryFilters',
        ...(widgetId ? [widgetId] : []),
      ]),
    }),
    queryClient.invalidateQueries({
      queryKey: prependRoleId([
        'datatables',
        cacheKey,
        ...(pageId ? [{ pageId }] : []),
        ...(widgetId ? [{ widgetId }] : []),
      ]),
    }),
    queryClient.invalidateQueries({
      queryKey: prependRoleId([
        'footerDataIrr',
        ...(widgetId ? [widgetId] : []),
      ]),
    }),
    queryClient.invalidateQueries({
      queryKey: prependRoleId([
        'footerDataNonIrr',
        ...(widgetId ? [widgetId] : []),
      ]),
    }),
  ]);
}
